<template>
  <div class="seomain">
    <div class="info-main">
      <div class="info-top">
        <span>加工工单：</span>
        {{ stinfo.order_code }}
      </div>
      <div class="info-mid">
        <h1>{{ stinfo.product_sku }}</h1>
        <p>加工SKU</p>
      </div>
      <div class="info-bottom text-center">
        <dl>
          <dt>加工日期</dt>
          <dd>{{ stinfo.starttime }}</dd>
        </dl>
        <dl>
          <dt>加工数量</dt>
          <dd>{{ stinfo.quantity }}</dd>
        </dl>
      </div>
    </div>

    <div class="tab-content">
      <div class="st-list-box pan-105">
        <div class="st-list" v-for="(v, k) in stlist" :key="k" :index="k">
          <div class="st-list-top">
            <div class="t-tit">{{ v.sku }}</div>
          </div>
          <div class="st-list-main">
            <p>库存编码：{{ v.code }}</p>
            <p>制造方编码：{{ v.manufacturercode }}</p>
            <p>产品名称：{{ v.stname }}</p>
            <p>型号：{{ v.model }}</p>
            <p>货架号：{{ v.position }}</p>
            <p>总数量：{{ v.total }}</p>
            <p>已备货数量：{{ v.received }}</p>
            <p v-if="flag != 'false'">已签收数量：{{ v.quantity }}</p>
            <van-field v-model="v.stnum" type="tel" label="签收数量" placeholder="请输入签收数量" />
          </div>
          <!-- <div class="st-list-bottom" v-if="flag != 'false'">
            <p class="st-opt-btn">申请领料</p>
          </div> -->
        </div>
      </div>
    </div>

    <!-- 一键入库 -->
    <div class="footer pf-btm">
      <div class="btn" @click="submit()" v-if="flag != 'false'">
        提交签收
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      dialog_num: "",
      show: !1,
      stlist: [],
      stinfo: {},
      oneinfo: {},
      paramsid: 0,
      activeid: 0,
    };
  },
  watch: {},
  computed: {
    flag() {
      return this.$route.params.flag;
    },
  },
  methods: {
    get_st_info: function() {
      let paramsid = this.$route.params.id;
      this.$post(this.$api.stGetJiagongInfo, { id: paramsid }).then((res) => {
        this.stinfo = res.data.info;
        this.stlist = res.data.list.filter((item) => {
          item.stnum = "";
          return item;
        });
      });
    },
    // 过滤无效数据
    rulesSubmitForm(dataList) {
      return dataList.filter((item) => {
        if (item.stnum > 0) {
          return item;
        }
      });
    },
    // 提交签收
    async submit() {
      let dataForm = this.rulesSubmitForm(this.stlist);
      console.log(dataForm.length);
      if (dataForm.length == 0) return this.$toast.fail("请填写必要字段");
      let params = [];
      dataForm.map((item) => {
        let obj = {};
        obj.id = item.process_products_id;
        obj.stnum = item.stnum;
        params.push(obj);
      });
      console.log(params);
      let result = await this.$post(this.$api.stGetJiagongEdit, params);
      this.$toast.success("提交成功");
      this.get_st_info();
    },
  },
  created() {
    this.get_st_info();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "加工" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.info-main {
  padding-top: 10px;
  background: #345;
  margin-bottom: 15px;
}
.info-main .info-top {
  color: #9ab;
  line-height: 2;
  margin: 0 20px;
}
.info-main .info-mid {
  text-align: center;
  color: #fff;
}
.info-main .info-mid h1 {
  line-height: 2.2;
  font-weight: normal;
}
.info-main .info-mid p {
  color: #9ab;
}
.info-main .info-bottom {
  display: flex;
  background: #2f3e50;
  border-top: 1px solid #9ab;
  margin-top: 20px;
  padding: 5px 0;
}
.info-main .info-bottom dl {
  flex: 1;
  line-height: 1.8;
}
.info-main .info-bottom dt {
  color: #9ab;
}
.info-main .info-bottom dd {
  color: #fff;
}

.info-scan {
  margin-top: 2.5em;
  margin-right: 1.5em;
}
.info-scan .van-icon {
  color: #0ba;
  font-size: 50px;
}

.info-detail-list {
  padding: 10px 20px;
  background: #fff;
}
.info-detail-list dl {
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  line-height: 30px;
  padding-top: 10px;
  padding-bottom: 5px;
}
.info-detail-list dt {
  flex: 1;
}
.info-detail-list .num {
  padding: 0 10px;
}
.info-detail-list .icon {
  color: #ddd;
  font-weight: bolder;
  font-size: 24px;
}

.status-00 {
  font-weight: normal;
}
.status-01 {
  color: #43cf7c;
}
.status-02 {
  color: #ff5733;
}
.van-cell.van-field {
  padding: 7px 0;
}
.seomain .tab-content {
  box-sizing: border-box;
  padding-bottom: 50px;
}
.footer {
  position: fixed;
  bottom: 0;
  height: 50px;
  box-sizing: border-box;
  padding: 5px 16px;
  width: 100%;
  height: 50px;
  border-top: 1px solid #cccccc;
  background-color: #fff;
}
.seomain .pf-btm .btn {
  box-sizing: border-box;

  text-align: center;
  line-height: 40px;
  color: #fff;
  border-radius: 16px;
  background-color: #00baad;
}
</style>
